export default "__VITE_ASSET__MFkotSMG__"